import React from 'react'
import aboutIcon from './assets/Icons/code2.apng'
import Icon from './Icon'

function Header({aboutRef,homeRef,skillsRef}) {

  function changeAnimation(e){
    const target = e.currentTarget;
    target.classList.toggle("open");
    const mobileMenu = document.getElementsByClassName("mobile_menu");
    mobileMenu[0].classList.toggle("show");
  }

  function hideShowAnimation(){
    const menuButton = document.getElementsByClassName("menu_button");
    menuButton[0].classList.toggle("open");
    const mobileMenu = document.getElementsByClassName("mobile_menu");
    mobileMenu[0].classList.toggle("show");
  }

  return (
    <>
      <div className="header">
        <div>
          <Icon width="55px" icon={aboutIcon} />
        </div>
        <div className="header_menu">
            <ul className="header_list">
                <button onClick={()=>homeRef.current.scrollIntoView()} className="home_item nav_btn">Home</button>
                <button onClick={()=>aboutRef.current.scrollIntoView()} className="about_item nav_btn">About</button>
                <button onClick={()=>skillsRef.current.scrollIntoView()} className="skills_item nav_btn">Skills</button>
                {/* <button onClick={()=>skillsRef.current.scrollIntoView()} className="skills_item nav_btn">Projects</button> */}
            </ul>
            <div onClick={changeAnimation} className="menu_button">
              <div className="menu_line1 menu_line"></div>
              <div className="menu_line2 menu_line"></div>
              <div className="menu_line3 menu_line"></div>
            </div>
        </div>
    </div>
    <div className="mobile_menu">
      <ul className="header_list">
                <button onClick={()=>{hideShowAnimation();homeRef.current.scrollIntoView()}} className="home_item nav_btn">Home</button>
                <button onClick={()=>{hideShowAnimation();aboutRef.current.scrollIntoView()}} className="about_item nav_btn">About</button>
                <button onClick={()=>{hideShowAnimation();skillsRef.current.scrollIntoView()}} className="skills_item nav_btn">Skills</button>
            </ul>
    </div>
    </>
  )
}

export default Header